import React, {Component} from 'react';
import { reviseTUser, adminloadTP, AuthenticatedUser, putToast, stopTimer } from "../../../api";
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import TournamentPageTemplate from '../tournamentPageTemplate'
import Modal from 'react-responsive-modal';

class TournamentAdminRoomJudges extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.getTdProps = this.getTdProps.bind(this);

        this.state = {
            loading: true,
            open: false,
            user: user,
            tData: {},
            assignments: [],
            pid: params.pid,
            selectedJudge: {},
        }

    }

    loadTournamentPage = () => {       
        if (this.state.pid) {
            adminloadTP('assignments', 'zulu', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    const data = this.buildData(d2.tournamentPage, d2.tUsers, d2.tournamentPage.currentRoundId);
                    const columns = this.buildColumns(d2.tournamentPage, d2.tournamentPage.currentRoundId);
                    this.setState({tData: d2.tournamentPage, tUsers: d2.tUsers, assignments: data, columns: columns, loading: false});                    
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
        }
    }

    getTdProps(state, rowInfo, column) {
        
        if (rowInfo && rowInfo.row && column.id !== 'judge') {
            if (true) {
                return {
                    onClick: () => { 
                        this.setState({selectedJudge: rowInfo.original, column: column.id, open: true})
                    },
                    onMouseOver: (e) => {
                        this.setState({
                            selected: rowInfo.index
                        })
                    },
                    style: {
                        background: rowInfo.index === this.state.selected ? '#d3dacf' : 'white',
                        //color: rowInfo.index === this.state.selected ? 'white' : 'black'
                    }
                }
            } else { 
                return {
                    style: {
                        background: rowInfo.index === this.state.selected ? '#d3dacf' : 'white',
                        //color: rowInfo.index === this.state.selected ? 'white' : 'black'
                    }
                }
            }
        } 
        if (rowInfo && rowInfo.row && column.id === 'judge') {
            return {
                onClick: () => { 

                },
                onMouseOver: (e) => {
                    this.setState({
                        selected: rowInfo.index
                    })
                },
                style: {
                    background: rowInfo.index === this.state.selected ? '#d3dacf' : 'white',
                    //color: rowInfo.index === this.state.selected ? 'white' : 'black'
                }
            }

        }
        return {}
    }

    onTUserUpdate(judge, roundId, eventId, roomId, isAssigned) {
        var tUser = this.state.tUsers.find(x=>x.userId === judge.userId)
        if (tUser && roundId && eventId && roomId) {
            var tUserRound = tUser.rounds.find(x=>x.roundId === roundId);            
            var tUserRoundEvent = tUserRound.events.find(x=>x.eventId === eventId);  
            var tUserRoundEventRoom = tUserRoundEvent.rooms.find(x=>x.roomId === roomId); 
            if (tUserRoundEventRoom) {
                tUserRoundEventRoom.isAssigned = isAssigned;
                tUserRoundEventRoom.noAssignReason = "override"
                if (!isAssigned) tUserRoundEventRoom.isReserved = false; // can't reserve if not assigned

                reviseTUser(tUser).then(d2 => {
                    if (!d2 || d2.error) {
                        console.log(d2 ? d2.error : "Error - no data");
                        putToast.error(d2 ? d2.error : "Error - no data");
                    } else {
                        putToast.success(d2.message); 
                        // doing this after so that the api can do the right thing, but we still want the update here 
                        if (tUserRoundEventRoom.hasAccepted) { tUserRoundEventRoom.hasAccepted = isAssigned; } // keep if assigned, remove otherwise
                      
                        const data = this.buildData(this.state.tData, this.state.tUsers, this.state.tData.currentRoundId);
                        const columns = this.buildColumns(this.state.tData, this.state.tData.currentRoundId);
                        this.setState({tUsers: this.state.tUsers, assignments: data, columns: columns})
                    }
                });
            }        
        }
    }

    
    onTUserReserve(judge, roundId, eventId, roomId, isReserved) {
        var tUser = this.state.tUsers.find(x=>x.userId === judge.userId)
        if (tUser && roundId && eventId && roomId) {
            var tUserRound = tUser.rounds.find(x=>x.roundId === roundId);            
            var tUserRoundEvent = tUserRound.events.find(x=>x.eventId === eventId);  
            var tUserRoundEventRoom = tUserRoundEvent.rooms.find(x=>x.roomId === roomId); 
            if (tUserRoundEventRoom) {
                tUserRoundEventRoom.isReserved = isReserved;
                if (tUserRoundEventRoom.isReserved) {
                    tUserRoundEventRoom.isAssigned = true;
                    tUserRoundEventRoom.noAssignReason = "override"
                }

                reviseTUser(tUser).then(d2 => {
                    if (!d2 || d2.error) {
                        console.log(d2 ? d2.error : "Error - no data");
                        putToast.error(d2 ? d2.error : "Error - no data");
                    } else {
                        putToast.success(d2.message); 
                      
                        const data = this.buildData(this.state.tData, this.state.tUsers, this.state.tData.currentRoundId);
                        const columns = this.buildColumns(this.state.tData, this.state.tData.currentRoundId);
                        this.setState({tUsers: this.state.tUsers, assignments: data, columns: columns})
                    }
                });
            }        
        }
    }

    onCloseModal = (mode, selectedJudge, column) => {
        this.setState({ open: false });
        const {roundId, eventId, roomId } = selectedJudge[column];

        switch(mode)
        {
            case 'assign': this.onTUserUpdate(selectedJudge, roundId, eventId, roomId, true)
            break;
            case 'unassign': this.onTUserUpdate(selectedJudge, roundId, eventId, roomId, false)
            break;
            case 'reserve': this.onTUserReserve(selectedJudge, roundId, eventId, roomId, true)
            break;
            case 'unreserve': this.onTUserReserve(selectedJudge, roundId, eventId, roomId, false)
            break;
            default: break;
        }
    };

    onCancelModal = () => {
        this.setState({ open: false });
    };

    buildData(tp, tUsers, roundId) {
        if (!tp || !tUsers || !roundId) return [];
        const data = [];
        const tRound = tp.rounds.find(x=>x._id === roundId);
        for(const tUser of tUsers) {
            const d = { 
                userId: tUser.userId,                   
                displayname: tUser.displayname, 
                phone: tUser.phone,
                email: tUser.email
            }
            const tuRound = tUser.rounds.find(x=>x.roundId === roundId)
            var index = 1;
            for(const tuEvent of tuRound.events) {
                for(const tuRoom of tuEvent.rooms) {
                    const tRoundEventRoom = tRound.events.find(x=>x.eventId === tuEvent.eventId).rooms.find(y=>y._id === tuRoom.roomId)
                    d[`room_${index++}`] = {roundId: roundId, eventId: tuEvent.eventId, ...tuRoom, reserved: tRoundEventRoom.reserved.includes(tUser.userId)};
                }
            }
            data.push(d)
        }
        return data;
    }
    
    buildColumns(tp, roundId) {
        if (!tp || !roundId) return [];

        const data = [];
        const tRound = tp.rounds.find(x=>x._id === roundId);
        var index = 1;
        for(const tEvent of tRound.events) {
            const c = {
                Header: tEvent.title,
                columns: []
            }
            for(const tRoom of tEvent.rooms) {
                var fcolor = (tRoom.judges.length) ? '#ffbb22' : '#ff7755';
                if (tRoom.judges.length >= tEvent.requiredJudgeCount) fcolor = '#99dd33';
                c.columns.push({                    
                    Header: <div style={{width: '100%', height: '100%', backgroundColor: fcolor}}>{`${index}`}</div>,
                    accessor: `room_${index}`,
                    maxWidth: 44,
                    style: {
                        textAlign: 'center',
                    },
                    Cell:  (props) => {
                        var color = (props.value.isAssigned) ? '#ffbb22' : '#ff7755';
                        if (props.value.isReserved) color = '#6688ff';
                        if (props.value.hasAccepted) color = '#99dd33';
                        return (
                          <div style={{width: '100%', height: '100%', backgroundColor: color}}>
                           {props.column.id.substring(5)}
                          </div>
                        )},
                    sortMethod: (a, b) => {
                        console.log(a);
                        var aval = (a.isAssigned) ? 1 : 3;
                        if (a.isReserved) aval = 2;
                        if (a.hasAccepted) aval = 0;
                        var bval = (b.isAssigned) ? 1 : 3;
                        if (b.isReserved) bval = 2;
                        if (b.hasAccepted) bval = 0;
                        return aval - bval;
                        }                        
                })
                index++;
            }
            data.push(c);
        }     
        data.push({
            id: 'judge',
            Header: 'Judge',
            accessor: 'displayname',
            minWidth: 100
        })       
        return data;
    }

    render(){
        if (this.state.loading) { return null; }

        stopTimer();      
        const { tData, user, assignments, columns, open, selectedJudge, column } = this.state;
        const row = selectedJudge && column ? selectedJudge[column] : null;
        return (
            <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Judge Room Assignments - ${user.displayname}`} title3=""
            bcTitle="Judge Room Assignments" bcParents={[
                {name: tData.title, url: `/pages/tournament/${tData._id}`},
                {name: "Administration", url: `/tournament/admin/${tData._id}`}
            ]}
            >              
            <div className="container-fluid">           
                <div className="row">
                    <div className="col-sm-12">
                        <ReactTable
                            filterable
                            defaultFilterMethod={ (filter, row, column) => {
                                const id = filter.pivotId || filter.id
                                return row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true
                            }}
                            data={assignments}
                            columns={columns}                                        
                            pageSize={(assignments.length > 60) ? 60 : assignments.length}
                            showPagination={(assignments.length > 60)}                    
                            getTdProps={this.getTdProps}                                                                                                     
                            />
                    </div>
                </div>  

                <Modal open={open} onClose={this.onCancelModal} >
                    <div className="modal-header">
                        <h5 className="modal-title f-w-600" id="exampleModalLabel2">Judge: {row ? row.displayname : null}
                        </h5>
                    </div>
                    <div className="modal-body">
                        <p><strong>Reason: </strong>
                        {row ? row.noAssignReason : null}</p>
                    </div>
                    <div className="modal-footer">
                        {row && !row.isAssigned && <button type="button" className="btn btn-primary" onClick={() => this.onCloseModal('assign', selectedJudge, column)}>Assign</button>}
                        {row && row.isAssigned && <button type="button" className="btn btn-primary" onClick={() => this.onCloseModal('unassign', selectedJudge, column)}>UnAssign</button>}
                        {row && !row.isReserved && <button type="button" className="btn btn-primary" onClick={() => this.onCloseModal('reserve', selectedJudge, column)}>Reserve</button>}
                        {row && row.isReserved && <button type="button" className="btn btn-primary" onClick={() => this.onCloseModal('unreserve', selectedJudge, column)}>UnReserve</button>}
                    </div>
                </Modal>                
            </div>
                        
            </TournamentPageTemplate>
        )
    }
}

export default TournamentAdminRoomJudges;